// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__os6By","footer__column":"style_footer__column__15tpb","column__image":"style_column__image__rxROI"};